module.exports = __webpack_public_path__ + "dfec667afc1dc90b943ee9f9561055eb.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/covers/cover_22.jpg
 ** module id = 605
 ** module chunks = 0
 **/